module.exports = __webpack_public_path__ + "assets/pace-mobile.16ba7153af24967539fa5c338ba1cee2.png";